import React from 'react';
import { Remote } from '@okapi/remote';
import type { RecommendedGoodsProps } from './types';
import { APP_MAIN_ID } from 'common/constants';

export const RecommendedGoods = ({
  placementId,
  title,
  pageType,
  id,
  productId,
  elementBlock,
  withDivider = false,
  _additionalProducts,
  _productsLimit,
  _abTestName,
}: RecommendedGoodsProps) => {
  if (!placementId) {
    return null;
  }

  const remoteData = {
    id: `${id}-carousel`,
    title,
    pageType,
    isFromPdp: true,
    isShared: true,
    withDivider,
    elementBlock,
    _productsLimit,
    _additionalProducts,
    requestData: {
      placementId,
      productId,
    },
    portalRootId: APP_MAIN_ID,
  };

  if (_abTestName) {
    Object.assign(remoteData, { _abTestName });
  }

  return <Remote widget="placements/product-carousel" id={`${id}-placement`} data={remoteData} />;
};
